import { UserOutlined }               from '@ant-design/icons';
import { Button }                     from 'antd';
import React, { useState, useEffect } from 'react';
import "./myProfile.scss";
import { useNavigate }                from 'react-router-dom';
import FormTable                      from '../../../reuseableComponents/Form/Form';
import Loader                         from '../../../reuseableComponents/Loader/Loader';
import { getMyInfoApi, updateUser }   from './apis/apis';
import Notification                   from "../../../reuseableComponents/Notification";

const MyProfile = () => {
  const [state, setState] = useState({
    isEdit: false,
    innerWidth: null,
    myProfileData: null,
    formData: [],
    initialValues: {},
    isLoader: true,
    reload: false
  })


  const navigation = useNavigate()
  let data = [
    {
      label: "ID",
      value: "idCard",
      type: "inp",
      options: []
    },
    {
      label: "Full Name",
      value: "name",
      type: "inp",
      options: []
    },
    {
      label: "Phone",
      value: "phone",
      type: "inp",
      options: []
    },
    {
      label: "Email",
      value: "email",
      type: "inp",
      options: []
    },
    {
      label: "Description",
      value: "description",
      type: "textArea",
      options: [],
      style: {
        gridColumn: "span 3"
      }
    },
    {
      label: "Photo",
      value: "photo",
      type: "upload",
      multiple:false,
      maxCount:1,
      options: []
    },
  ]

  const getMyInfoFunc = async () => {
    setState({
      ...state,
      isLoader: true
    })
    try {
      let result = await getMyInfoApi();

      if (result?.status) {
        let response = result.data.data;

        const newData = !!data.length && data.map(item => {
          if (item.value === "photo" && response.hasOwnProperty(item.value)) {
            return {
              ...item,
              defaultValue: response[item.value] ? [{
                url: response[item.value],
                uid: "-1",
                name: "file.jpg",
                status: "done"
              }] : null
            };
          } else if (response.hasOwnProperty(item.value)) {
            return {
              ...item,
              defaultValue: response[item.value]
            };
          } else {
            return {
              ...item,
              defaultValue: null
            };
          }
        });


        setState({
          ...state,
          myProfileData: response,
          formData: newData,
          isLoader: false
        });

      }
    }
    catch (err) {
      console.error("Error fetching profile info:", err);
      setState({
        ...state,
        isLoader: false
      })
    }
  };

  const updateUserFunction = async (data) => {
    try {
      let myData = {
        ...data,
        photo:!!data?.photo.length > 0 ? data?.photo[0]?.response?.data[0] : null
      }

      if(data?.name !== '' && data?.phone !== '' && data?.email !== '' && data?.description !== ''){
        let result = await updateUser(myData);

        if (result?.data?.success) {
          let response = result.data.data;

          const newData = Object.keys(data).map(key => ({
            ...data[key],
            defaultValue: response.hasOwnProperty(data[key].value) ? response[data[key].value] : null
          }));

          setState({
            ...state,
            myProfileData: response,
            formData: newData,
            isEdit: false,
            reload: !state.reload
          });
        }
      }
      else{
        Notification('error', "Validation Error", "Please fill all the fields");
      }

    }
    catch (err) {
      console.error("Error fetching profile info:", err);
    }
  };

  useEffect(() => {
    getMyInfoFunc()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.reload]);

  return !state.isEdit ?
    (state.isLoader ? <Loader/> :
        <div className={ "myProfileContainer" }>
          <div className={ "upper-content" }>
            {
              state?.myProfileData?.photo ?
                <img src={ state?.myProfileData?.photo } alt="profileImage" className={ "myProfileImage" }/> :
                <UserOutlined style={{
                  fontSize:60
                }}/>
            }

            <h5>{ state.myProfileData?.name }</h5>
            <div className={ "data-content" } style={ { marginTop: "10%" } }>
              <h5>Phone</h5>
              <p>{ state.myProfileData?.phone }</p>
            </div>
            <div className={ "data-content" }>
              <h5>Email</h5>
              <p>{ state.myProfileData?.email }</p>
            </div>
            <div className={ "data-content" }>
              <h5>Description</h5>
              <p>{ state.myProfileData?.description } </p>
            </div>
            <div style={ {
              display: "flex",
              justifyContent: "end",
              gap: 10,
              marginTop: 20
            } }>
              {state?.myProfileData?.renter && <Button type={"primary"} onClick={() => navigation("/myProperties")}>My Properties</Button>}
              <Button onClick={ () => setState({
                ...state,
                isEdit: true
              }) } type={ "primary" } style={ {
                background: "#1E1E1E"
              } }>Edit Profile</Button>
            </div>
          </div>
        </div>
    ) : <div className={ "main-settings-container" }>
      <Button type={ "text" } onClick={ () => setState({ ...state, isEdit: false }) }>Back</Button>
      <FormTable data={ state.formData } customStyle={
        {
          display: window.innerWidth > 790 ? "grid" : "",
          gridTemplateColumns: window.innerWidth > 790 ? "32% 32% 32%" : "100%",
          justifyContent: "space-between",
          gap: 20,
          width: "100%",
          marginTop: "3%"
        } } buttonLabel={ "Save" }
                 heading={ "Edit Profile" }
                 saveFunc={ updateUserFunction }
                 initialValues={ state.formData }
      />
    </div>
}

export default MyProfile